import type { UsuarioSesion } from "./sesion"

/**
 * ⚠ **Esto es COSMÉTICO.** Sirve para no enseñar un botón que va a dar 403.
 *
 * El servidor es quien decide, en `services/authz.py::can()`, en cada request.
 * Esconder un botón no es un permiso: quien quiera saltárselo abre la consola
 * del navegador y llama al endpoint directamente. Si alguna vez esta función es
 * la única comprobación de algo, eso es un agujero, no una optimización.
 */
export function tienePermiso(usuario: UsuarioSesion | null, clave: string): boolean {
  if (!usuario) return false
  return usuario.permisos.includes(clave)
}

export function tieneAlguno(usuario: UsuarioSesion | null, claves: string[]): boolean {
  return claves.some((c) => tienePermiso(usuario, c))
}

export function esCliente(usuario: UsuarioSesion | null): boolean {
  return usuario?.tipo === "CLIENTE"
}

/** El intermediario del portal de transporte (25/10): sólo entra en `transporte.*`. */
export function esTransportista(usuario: UsuarioSesion | null): boolean {
  return usuario?.tipo === "TRANSPORTISTA"
}

/** Alguien de fuera de la agencia: sin campanita, ficha laboral ni reporte de fallas. */
export function esExterno(usuario: UsuarioSesion | null): boolean {
  return esCliente(usuario) || esTransportista(usuario)
}
